module.exports = __webpack_public_path__ + "media/images/trash-grey-bc4973515f9a285dc81db58663f2aee2.svg";